import React, { useContext } from "react";
import { SpreadPriceContext } from "../../../../context/market-watch/SpreadPriceContext";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { COLORS } from "../../../../ui/Theme";
import { Percent } from "@mui/icons-material";

const SpreadPriceForm = () => {
  const { percent, setPercent } = useContext(SpreadPriceContext);

  const handleChangeStrikeDeviation = (e) => {
    if (e.target.value > 0)
      setPercent({
        ...percent,
        [e.target.name]: e.target.value,
      });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "12px",
          color: COLORS.GRAY,
          width: { xs: "200px", md: "100px" },
        }}
      >
        اختلاف قیمت اعمال با قیمت سهم
      </Typography>
      <TextField
        name="strike_deviation"
        value={percent.strike_deviation}
        onChange={handleChangeStrikeDeviation}
        type="text"
        sx={{
          width: { xs: "100%", md: "100px" },
          "& .MuiInputBase-input": {
            textAlign: "center",
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Percent sx={{ color: COLORS.GRAY, width: "15px" }} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default SpreadPriceForm;
